import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Services } from '@/services/services'

import './Main.css'
import { Translates } from '@/services/repository/i18n'
import { MainPageLayout } from '@/components/layout/MainLayout'
import { CurrentSession } from '@/services/repository/session'
import { CleanWizardData, LoadWizardData, SaveWizardData, WizardData } from './Model'
import { BackButton } from '@/components/layout/NavBar'
import { useSpeechRecognition } from '@/hooks/useSpeechRecognition'

export const SupportWizardStep4 = ({
  services,
  session
}: {
  services: Services
  session?: CurrentSession
}) => {
  const navigate = useNavigate()
  const [translates, setTranslates] = useState<Translates>()
  const [wizardData, setWizardData] = useState<WizardData | undefined>()
  const [isListening, setIsListening] = useState(false)

  useEffect(() => {
    const data = LoadWizardData()
    setWizardData(data)
  }, [])

  const { start, stop } = useSpeechRecognition({
    lang: session?.user.lang || services.i18n.defaultLang() || 'pl',
    baseText: wizardData?.content || '',
    onResult: (text) => {
      setWizardData((prev) => {
        if (!prev) return prev
        var data = { ...prev, content: text }
        SaveWizardData(data)
        return data
      })
    },
    onError: (err) => console.error('Speech error:', err)
  })

  const toggleListening = () => {
    if (!wizardData) return
    if (isListening) {
      stop()
    } else {
      start()
    }
    setIsListening((prev) => !prev)
  }

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
    } else {
      services.i18n.get('main').then(setTranslates)
    }
  }, [session])

  if (
    !translates ||
    !wizardData
  ) {
    return <div className='spinner'></div>
  }

  return (
    <MainPageLayout
      pageName='support-wizard'
      services={services}
      translates={translates}
      session={session}
      navbarLeft={
        <BackButton
          services={services}
          translates={translates}
          replaceUrl={`/communal/support/wizard/page3`}
        />
      }
    >
      <h2 className='page-title'>{translates.for(`wizards.support_question.title`)}</h2>

      <div className='content-box'>
        <textarea
          value={wizardData.content}
          onChange={(e) =>
            setWizardData((prev) => {
              if (!prev) return
              var data = { ...prev, content: e.target.value }
              SaveWizardData(data)
              return data
            })
          }
          placeholder={translates.for(`wizards.support_question.content_placeholder`)}
          readOnly={isListening}
        />
      </div>

      <div
        className={isListening ? 'record-btn pulse' : 'record-btn'}
        onClick={toggleListening}
      >
        {isListening
          ? translates.for(`wizards.support_question.stop_recording`)
          : translates.for(`wizards.support_question.record`)}
        <img
          src={`/public/img/icons/microphone.svg`}
          style={{ opacity: isListening ? 0.5 : 1 }}
        />
      </div>


      <div className='approve-btn' onClick={() => {
        SaveWizardData(wizardData)
        navigate(`/communal/support/wizard/page5`, { replace: true })
      }}>
        {translates.for(`wizards.support_question.next`)}
      </div>

    </MainPageLayout>
  )
}
